import { httpClient } from '@/infra/protocols/http';
import { IProjectDetailsDTO } from '@/modules/projects/dtos/project.dto';
import { IProjectDetails } from '@/modules/projects/entities/project.entity';
import { ProjectDetailsMapper } from '@/modules/projects/mappers/project-details.mapper';

export async function getProjectDetails(
  params: GetProjectDetailsService.Params,
): Promise<GetProjectDetailsService.Response> {
  const response = await httpClient.get<IProjectDetailsDTO>(`/v1/projetos/${params.projectId}`);
  return ProjectDetailsMapper.toPresentation(response);
}

export namespace GetProjectDetailsService {
  export interface Params {
    projectId: string;
  }

  export type Response = IProjectDetails;
}
